/*
 * PDP image lightbox -- 2026-09-02.
 *
 * Click any main gallery image on a product page and it opens full-bleed, with
 * the rest of the product's shots one swipe / scroll / arrow-key away.
 *
 * Loaded, with assets/vu-gallery.css, by sections/main-product.liquid only.
 *
 * WHY IT DOES NOT USE THE GALLERY DOM AS ITS SOURCE
 * The main gallery is a slick carousel (see assets/main.js, "single-product
 * slider start"). slick defaults to infinite:true, so it CLONES slides --
 * querying .single-product__big-item img would return the four real shots plus
 * however many clones slick decided to make, in slick's order, and the
 * lightbox would show duplicates. The section therefore emits the real list as
 * JSON and each tile keeps its Shopify media id; a click looks the id up. A
 * clone carries its original's id, so a click on one opens the right image.
 *
 * WHY IT IS VANILLA
 * Nothing here needs jQuery, and the theme is trying to shed it rather than
 * add to it -- removing jQuery today makes Klaviyo pull its own copy off
 * cdnjs, so the dependency is already on a list to unwind. A new file that
 * does not join in keeps that list from growing.
 *
 * WHY THE TRACK IS A NATIVE SCROLLER
 * A second slick instance would give swipe and nothing else. A scroll-snap
 * track answers "scroll across in that format too" literally: trackpad,
 * touch, shift+wheel and the arrow buttons all drive the same scroller, and
 * the browser does the physics.
 */
(function () {
  'use strict';

  var DRAG_SLOP = 6; // px of pointer travel that turns a click into a drag

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    var dataEl = document.querySelector('[data-vu-gallery-data]');
    var galleryEl = document.querySelector('.single-product_big-items');
    if (!dataEl || !galleryEl) { return; }

    var images;
    try { images = JSON.parse(dataEl.textContent); }
    catch (e) { return; }
    if (!Array.isArray(images) || !images.length) { return; }

    /* ---------------------------------------------------------------- build */

    var overlay = document.createElement('div');
    overlay.className = 'vu-zoom' + (images.length < 2 ? ' vu-zoom--single' : '');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Product image viewer');

    var arrow = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false">' +
                '<path d="M7.5 1L2.5 6l5 5" fill="none" stroke="currentColor" stroke-width="1.5" ' +
                'stroke-linecap="round" stroke-linejoin="round"/></svg>';

    overlay.innerHTML =
      '<button type="button" class="vu-zoom__close" aria-label="Close image viewer">' +
        '<svg viewBox="0 0 14 14" aria-hidden="true" focusable="false">' +
        '<path d="M1 1l12 12M13 1L1 13" fill="none" stroke="currentColor" stroke-width="1.5" ' +
        'stroke-linecap="round"/></svg>' +
      '</button>' +
      '<button type="button" class="vu-zoom__nav vu-zoom__nav--prev" aria-label="Previous image">' + arrow + '</button>' +
      '<button type="button" class="vu-zoom__nav vu-zoom__nav--next" aria-label="Next image" ' +
        'style="transform:translateY(-50%) rotate(180deg)">' + arrow + '</button>' +
      '<div class="vu-zoom__track"></div>' +
      '<p class="vu-zoom__counter" aria-hidden="true"></p>' +
      '<p class="vu-zoom__status" role="status" aria-live="polite"></p>';

    var track    = overlay.querySelector('.vu-zoom__track');
    var counter  = overlay.querySelector('.vu-zoom__counter');
    var status   = overlay.querySelector('.vu-zoom__status');
    var closeBtn = overlay.querySelector('.vu-zoom__close');
    var prevBtn  = overlay.querySelector('.vu-zoom__nav--prev');
    var nextBtn  = overlay.querySelector('.vu-zoom__nav--next');

    images.forEach(function (img) {
      var slide = document.createElement('div');
      slide.className = 'vu-zoom__slide';
      var el = document.createElement('img');
      el.className = 'vu-zoom__img';
      // Deferred to open time so a visitor who never zooms never downloads the
      // full-size set. See setSources().
      el.setAttribute('data-src', img.src || '');
      if (img.srcset) { el.setAttribute('data-srcset', img.srcset); }
      el.setAttribute('sizes', '100vw');
      el.alt = img.alt || '';
      if (img.width)  { el.width  = img.width; }
      if (img.height) { el.height = img.height; }
      el.decoding = 'async';
      el.draggable = false;
      slide.appendChild(el);
      track.appendChild(slide);
    });

    document.body.appendChild(overlay);

    var slides = Array.prototype.slice.call(track.querySelectorAll('.vu-zoom__slide'));
    var current = 0;
    var lastFocused = null;
    var scrollY = 0;

    /* ------------------------------------------------------------ behaviour */

    function setSources(i) {
      var img = slides[i] && slides[i].querySelector('img');
      if (!img || img.src) { return; }
      var srcset = img.getAttribute('data-srcset');
      if (srcset) { img.srcset = srcset; }
      img.src = img.getAttribute('data-src');
    }

    // The neighbours too, so a swipe does not land on an empty frame.
    function primeAround(i) {
      setSources(i);
      setSources(i - 1);
      setSources(i + 1);
    }

    function paint(i) {
      current = i;
      counter.textContent = (i + 1) + ' / ' + images.length;
      status.textContent = 'Image ' + (i + 1) + ' of ' + images.length +
                           (images[i] && images[i].alt ? '. ' + images[i].alt : '');
      prevBtn.disabled = (i === 0);
      nextBtn.disabled = (i === images.length - 1);
      primeAround(i);
    }

    function goTo(i, behavior) {
      i = Math.max(0, Math.min(images.length - 1, i));
      primeAround(i);
      track.scrollTo({ left: track.clientWidth * i, behavior: behavior || 'smooth' });
      paint(i);
    }

    function isOpen() {
      return overlay.classList.contains('is-open');
    }

    function open(i) {
      lastFocused = document.activeElement;
      scrollY = window.scrollY || window.pageYOffset || 0;

      document.body.style.top = '-' + scrollY + 'px';
      document.body.classList.add('vu-zoom-open');

      /*
       * Land on the right image BEFORE the overlay is shown, and do it
       * synchronously. The overlay is permanently laid out (see the note in
       * vu-gallery.css), so clientWidth is already valid and there is nothing
       * to wait for -- an earlier version deferred this to a
       * requestAnimationFrame and opened on the previous image whenever the
       * frame did not run.
       *
       * behavior:'auto' so it is a jump, not a visible skate across the other
       * shots on the way to the one that was clicked.
       */
      primeAround(i);
      track.scrollTo({ left: track.clientWidth * i, behavior: 'auto' });
      paint(i);

      /*
       * Synchronous. No frame is needed for the fade: the overlay is always
       * laid out, so `opacity: 0` is already its computed start value and the
       * transition runs from it. Deferring this to requestAnimationFrame --
       * which an earlier version did, and which a throttled or background tab
       * can delay indefinitely -- left the page scroll-locked behind an
       * overlay that had not appeared yet, with Escape refusing to fire
       * because the script did not consider itself open.
       */
      overlay.classList.add('is-open');

      closeBtn.focus({ preventScroll: true });
    }

    function close() {
      overlay.classList.remove('is-open');
      document.body.classList.remove('vu-zoom-open');
      document.body.style.top = '';
      window.scrollTo(0, scrollY);

      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus({ preventScroll: true });
      }
    }

    /* --------------------------------------------------------------- wiring */

    // Which image did the visitor click? Match on Shopify's media id so a
    // slick clone resolves to its original. Falls back to first.
    function indexForTile(tile) {
      var id = tile.getAttribute('data-media-id');
      for (var i = 0; i < images.length; i++) {
        if (String(images[i].id) === String(id)) { return i; }
      }
      return 0;
    }

    // slick's slides are draggable, and a drag ends in a click. Only open when
    // the pointer barely moved.
    var downX = 0, downY = 0, moved = false;

    galleryEl.addEventListener('pointerdown', function (e) {
      downX = e.clientX; downY = e.clientY; moved = false;
    });

    galleryEl.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientX - downX) > DRAG_SLOP ||
          Math.abs(e.clientY - downY) > DRAG_SLOP) { moved = true; }
    });

    galleryEl.addEventListener('click', function (e) {
      var tile = e.target.closest('.single-product__big-item');
      if (!tile || moved) { return; }
      e.preventDefault();
      open(indexForTile(tile));
    });

    // Keyboard: the tiles are not natively focusable, so the section marks each
    // one up as a button. Enter/Space arrive as a click, which the handler
    // above already covers -- this only needs to stop Space scrolling the page.
    galleryEl.addEventListener('keydown', function (e) {
      if (e.key !== ' ' && e.key !== 'Spacebar') { return; }
      if (e.target.closest('.single-product__big-item')) { e.preventDefault(); }
    });

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { goTo(current - 1); });
    nextBtn.addEventListener('click', function () { goTo(current + 1); });

    // Click the backdrop -- but not the image -- to dismiss.
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.classList.contains('vu-zoom__slide')) { close(); }
    });

    document.addEventListener('keydown', function (e) {
      if (!isOpen()) { return; }
      if (e.key === 'Escape')     { close(); }
      else if (e.key === 'ArrowRight') { goTo(current + 1); }
      else if (e.key === 'ArrowLeft')  { goTo(current - 1); }
      else if (e.key === 'Tab')   {
        // Two-stop focus trap: the overlay's only tabbables are its buttons.
        var stops = [closeBtn, prevBtn, nextBtn].filter(function (b) { return !b.disabled; });
        var i = stops.indexOf(document.activeElement);
        e.preventDefault();
        var next = e.shiftKey ? i - 1 : i + 1;
        if (next < 0) { next = stops.length - 1; }
        if (next >= stops.length) { next = 0; }
        stops[next].focus();
      }
    });

    // Keep the counter honest when the visitor drives the scroller directly.
    var settle;
    track.addEventListener('scroll', function () {
      window.clearTimeout(settle);
      settle = window.setTimeout(function () {
        var w = track.clientWidth;
        if (!w) { return; }
        var i = Math.round(track.scrollLeft / w);
        if (i !== current) { paint(i); }
      }, 90);
    }, { passive: true });

    // A resize changes the slide width, so the saved offset no longer points
    // at the current image.
    window.addEventListener('resize', function () {
      if (!isOpen()) { return; }
      track.scrollTo({ left: track.clientWidth * current, behavior: 'auto' });
    });
  });
})();
